'use client'

import { useSetAtom } from 'jotai'
import { useCallback } from 'react'

import { SettingTab } from '@/lib/configs/setting-config'
import { settingsDialogRequestAtom } from '@/state/settings-dialog'

/** Opens the Settings dialog on Accounts with the "Add account" button spotlit. */
export function useOpenAddAccountDialog() {
  const setRequest = useSetAtom(settingsDialogRequestAtom)
  return useCallback(
    () => setRequest({ tab: SettingTab.ACCOUNT, highlightAddAccount: true }),
    [setRequest]
  )
}
